<template>
  <div class="data-viewer-container">
    <div class="wrapper">
      <DataViewer v-if="mapStore.state.nodePath.length === 0 && !mapStore.state.defGuide" :map="mapStore.state.map"/>
      <DataViewer v-if="mapStore.state.rct" :key="mapStore.state.rct.id" :rct="mapStore.state.rct"/>
      <DataViewer v-if="mapStore.state.sr" :key="mapStore.state.sr.id" :sr="mapStore.state.sr"/>
      <DataViewer v-if="mapStore.state.prot" :key="mapStore.state.prot.id" :prot="mapStore.state.prot"/>
      <DataViewer v-if="mapStore.state.def" :key="mapStore.state.def.id" :def="mapStore.state.def"/>
      <DataViewer v-if="mapStore.state.guide" :key="mapStore.state.guide.id" :guide="mapStore.state.guide"/>
    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent} from "vue";
import {useMapStore} from "@/mixins/mapStore";
import DataViewer from "@/components/DataViewer.vue"
export default defineComponent(
    {
      name: "DataViewerContainer",
      components: {DataViewer},
      setup(props){
       return {
         mapStore: useMapStore()
       }
      }
    }
)
</script>
<style lang="scss">
.data-viewer-container{
  height: 100%;
  display: flex;
  flex-direction: column;
  .wrapper{
    height: 0;
    flex-grow: 1;
    overflow: auto;
  }
}
</style>